module.exports = __webpack_public_path__ + "static/01-designing-small-6904228e318e7e828fbe26f32387f2d1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/homepage/01-designing-small.jpg
// module id = 2637
// module chunks = 35783957827783